import { render, staticRenderFns } from "./VendorAgents.vue?vue&type=template&id=57e10944"
import script from "./VendorAgents.vue?vue&type=script&lang=js"
export * from "./VendorAgents.vue?vue&type=script&lang=js"
import style0 from "./VendorAgents.vue?vue&type=style&index=0&id=57e10944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports